import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, MessageCircle, User, Package, Plus, Tag, Wallet, Briefcase } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, unreadMessagesCount, isAuthenticated } = useApp();

  const isSeller = user?.role === 'seller';

  const buyerNavItems = [
    { path: '/', icon: Home, label: 'Browse' },
    { path: '/services', icon: Briefcase, label: 'Services' },
    { path: '/messages', icon: MessageCircle, label: 'Messages', badge: unreadMessagesCount },
    { path: '/orders', icon: Package, label: 'Orders' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  const sellerNavItems = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/sell', icon: Plus, label: 'Sell', highlight: true },
    { path: '/my-listings', icon: Tag, label: 'Listings' },
    { path: '/wallet', icon: Wallet, label: 'Wallet' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  const navItems = isAuthenticated && isSeller ? sellerNavItems : buyerNavItems;

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-xl border-t border-stone-200/60 z-50" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="max-w-lg mx-auto flex items-center justify-around h-16 px-2">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            data-testid={`nav-${item.label.toLowerCase()}`}
            className={`flex flex-col items-center justify-center flex-1 h-full relative transition-all duration-200 ${
              item.highlight 
                ? 'text-white' 
                : isActive(item.path)
                  ? 'text-minted-800'
                  : 'text-stone-400 hover:text-stone-600'
            }`}
          >
            {item.highlight ? (
              <div className="w-11 h-11 bg-minted-800 rounded-sm flex items-center justify-center -mt-4 hover:bg-minted-700 transition-colors">
                <item.icon className="w-5 h-5 text-white" strokeWidth={1.5} />
              </div>
            ) : (
              <>
                <div className="relative">
                  <item.icon className={`w-5 h-5 ${isActive(item.path) ? 'stroke-[2px]' : ''}`} strokeWidth={1.5} />
                  {item.badge > 0 && (
                    <span className="absolute -top-1 -right-1 w-4 h-4 bg-minted-700 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                      {item.badge > 9 ? '9+' : item.badge}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] mt-1 tracking-wide ${isActive(item.path) ? 'font-semibold' : 'font-medium'}`}>
                  {item.label}
                </span>
              </>
            )}
            {!item.highlight && isActive(item.path) && (
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-minted-700" />
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
